export const getNextReviewPage = async (
  parentSpaceId: string,
  reviewLimit: number,
  offset: number,
  accessToken: string,
) => {
  try {
    const url = `/v1/reviews/space/${parentSpaceId}?complete=true&public=true&limit=${reviewLimit}&offset=${offset}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(
        `Error in fetching next page of reviews: ${response.status}`,
      );
    }

    return response.json();
  } catch (error) {
    throw new Error(`Error in fetching next page of reviews: ${error}`);
  }
};
